export const IS_UNIVERSAL_PARTNER =
  window.location.hostname === "virtuales.pro";
